import MultiProvinceFilter from "../../Shared/MultiProvinceFilter";
import { PaginatedHolidaysQueryVariables } from "@/graphql/__generated__/graphql";

interface Props {
  displayAmount: number;
  handleSubmitClick: (_variables: PaginatedHolidaysQueryVariables) => void;
}

/**
 * Holidays specific province filter configuration
 */
const holidaysProvinceConfig = {
  paginationStateKey: "paginatedHolidays" as keyof PaginationState,
  buildQueryVariables: (
    displayAmount: number,
    filters: any,
    provinces: string[] | null
  ): PaginatedHolidaysQueryVariables => ({
    first: displayAmount,
    filters: {
      date: filters.date || null,
      provinces,
    },
  }),
  extractFilters: (paginationState: any) => paginationState?.filters || {},
};

function HolidaysProvinceDropdown(props: Props) {
  const { displayAmount, handleSubmitClick } = props;

  return (
    <MultiProvinceFilter
      displayAmount={displayAmount}
      handleSubmitClick={handleSubmitClick}
      config={holidaysProvinceConfig}
    />
  );
}

export default HolidaysProvinceDropdown;
